import * as React from 'react'
// CComponents
import {Link} from '@frontrow/console/src/components/ui/link'

// Type
import {type ImportFileType} from '@frontrow/console/src/components/pages/import-sis-ids'
// Style
import * as style from './import-row.module.scss'

type Props = {
  title: string
  type: ImportFileType
  onImport: (event: React.ChangeEvent<HTMLInputElement>, fileType: ImportFileType) => void
  uploaded: boolean
  description: string
  templateUrl: string
}

export default function ImportRow(props: Props): React.ReactElement {
  const {title, type, onImport, uploaded, description, templateUrl} = props

  const uploadedCheck = uploaded ? (
    <div className={style.uploadedCheck}>
      <i className="fa fa-check-circle fa-2x" />
    </div>
  ) : null

  return (
    <div className={style.importRow}>
      <div className={style.rowDescription}>
        <strong className={style.title}>{title}</strong>
        <br />
        {description} <Link href={templateUrl}>(template)</Link>
      </div>
      <div className={style.uploadBtn}>
        <strong>Upload {title} csv</strong>
        <input type="file" onChange={event => onImport(event, type)} />
      </div>
      {uploadedCheck}
    </div>
  )
}
